import React, { Component, Fragment } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { Link } from 'office-ui-fabric-react/lib/Link';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import { post } from 'services/request';
import { localizable } from 'components/Localization';

@localizable
@observer
export default class NotificationPreview extends Component {
  @observable isOpen = false;
  @observable isLoading = false;

  @observable groups = [];
  @observable selectedGroup = -1;

  open = async () => {
    const { action, query, data } = this.props;

    const url = !!query
      ? action +
      (action.indexOf('?') >= 0 ? '&' : '?') +
      Object.keys(query)
        .map(
          (k) => encodeURIComponent(k) + '=' + encodeURIComponent(query[k])
        )
        .join('&')
      : action;

    this.groups = [];
    this.isOpen = true;
    this.isLoading = true;
    try {
      this.groups = await post(url, data);
      this.selectedGroup = 0;
    } catch (error) {
      this.isOpen = false;
      throw error;
    } finally {
      this.isLoading = false;
    }
  };

  // trigger = 'button' | 'icon'
  render() {
    const { trigger, t } = this.props;

    return (
      <Fragment>
        {trigger === 'button' && (
          <DefaultButton onClick={this.open}>{t('Preview')}</DefaultButton>
        )}
        {trigger === 'icon' && (
          <Link onClick={this.open} title={t('Preview')}>
            <Icon iconName="Zoom"></Icon>
          </Link>
        )}
        {this.isOpen && (
          <Modal
            isOpen={true}
            onDismiss={() => (this.isOpen = false)}
            isBlocking={false}
            containerClassName="notification--preview--modal"
          >
            <div style={{ flex: 'none' }}>
              {this.groups.map((group, index) => (
                <Fragment key={index}>
                  {index === this.selectedGroup ? (
                    <PrimaryButton
                      onClick={() => {
                        this.selectedGroup = index;
                      }}
                    >
                      {t("notificationcaption::" + group.caption)}
                    </PrimaryButton>
                  ) : (
                    <DefaultButton
                      onClick={() => {
                        this.selectedGroup = index;
                      }}
                    >
                      {t("notificationcaption::" + group.caption)}
                    </DefaultButton>
                  )}
                </Fragment>
              ))}
            </div>
            <div
              style={{
                flex: '1 1 auto',
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                border: '1px solid #EE7F01',
                padding: '20px',
                paddingTop: 0,
              }}
            >
              {this.isLoading && (
                <div
                  style={{
                    flex: '1 1 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Spinner size={SpinnerSize.medium} />
                </div>
              )}
              {this.groups.map((group, index) => (
                <div
                  key={index}
                  style={{
                    flex: '1 1 auto',
                    display: index === this.selectedGroup ? 'flex' : 'none',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    height: '100%',
                  }}
                >
                  {group.notifications.map((notification, index2) => (
                    <Fragment key={index2}>
                      <h3>{t(notification.caption)}</h3>
                      <iframe
                        title="notification_preview_iframe"
                        src={notification.url}
                        style={{
                          flex: notification.short ? 'none' : '1 1 auto',
                          height: notification.short ? '70px' : 'auto',
                        }}
                      ></iframe>
                    </Fragment>
                  ))}
                </div>
              ))}
              {this.groups.length === 0 && !this.isLoading && (
                <div
                  style={{
                    flex: '1 1 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {t('No notification defined for the selected action')}
                </div>
              )}
            </div>
          </Modal>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/NotificationPreview/index.jsx